exports = module.exports = require("../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-864764d6] .el-tabs__item {\n  color: #999 !important;\n}\n[data-v-864764d6] .is-active {\n  color: #409eff !important;\n}\n.yd-tags[data-v-864764d6] {\n  margin-bottom: 0;\n}\n[data-v-864764d6] .el-tabs__item.is-active {\n  color: #22c655 !important;\n  border-color: #22c655 !important;\n}", ""]);

// exports
